import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { InMemoryStorageService } from '../../services/in-memory-storage.service';
export interface UserProfile {
    id: number;
    userName: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    mobile: string;
    status: string;
    createdAt: string;
    facility: string;
    warehouse: string;
    m3ResponsibleId: string;
    division: string;
    company: string;
    sub: string;
    roleGroups: string[]; // <-- Add this line
}

@Injectable({ providedIn: 'root' })
export class UserService {
    public companyId: string = '';
    public divisionId: string = '';
    public userName: string = '';

    constructor(
        private http: HttpClient,
        private inMemoryStorage: InMemoryStorageService // <-- inject here
    ) {}

    setCompanyAndDivision(companyId: string, divisionId: string) {
        this.companyId = companyId;
        this.divisionId = divisionId;
        console.log(`Setting companyId: ${companyId}, divisionId: ${divisionId}`);

        this.inMemoryStorage.set('companyId', companyId);
        this.inMemoryStorage.set('divisionId', divisionId);
    }

    getCompanyId() {
        return this.companyId || this.inMemoryStorage.get('companyId') || '';
    }

    getDivisionId() {
        return this.divisionId || this.inMemoryStorage.get('divisionId') || '';
    }

    setUserName(userName: string) {
        this.userName = userName;
        console.log(`Setting userName: ${userName}`);
        this.inMemoryStorage.set('userName', userName);
    }

    getUserName(): string {
        return this.userName || this.inMemoryStorage.get('userName') || '';
    }

    getUserProfile(username: string): Observable<UserProfile> {
        const url = `${environment.authApiUrl}username?username=${username}`;
        return this.http.get<UserProfile>(url);
    }

    updateUserProfile(profile: Partial<UserProfile> & { userName: string }): Observable<any> {
        const url = `${environment.authApiUrl}update`;
        // Map fields to API body
        const body = {
            username: profile.userName,
            phoneNumber: profile.mobile,
            facility: profile.facility,
            warehouse: profile.warehouse,
            division: profile.division,
            company: profile.company,
            m3ResponsibleId: profile.m3ResponsibleId
        };
        return this.http.post<any>(url, body, { responseType: 'text' as 'json' });
    }

    disableUsers(emails: string[]): Observable<any> {
        const url = `${environment.authApiUrl}disable`;
        const body = { emails };
        return this.http.post<any>(url, body, { responseType: 'text' as 'json' });
    }

    enableUsers(emails: string[]): Observable<any> {
        const url = `${environment.authApiUrl}enable`;
        const body = { emails };
        return this.http.post<any>(url, body, { responseType: 'text' as 'json' });
    }

    // user.service.ts
sendForgotPasswordLink(usernameOrEmail: string) {
  const url = `${environment.authApiUrl}generate`;
  const body = { usernameOrEmail, purpose: 'Forgot Password' };
  return this.http.post(url, body, { responseType: 'text' }); // plain text
}

verifyOtp(usernameOrEmail: string, otp: string) {
  const url = `${environment.authApiUrl}otp-verify`;
  const body = { usernameOrEmail, otp, purpose: 'Forgot Password' };
  return this.http.post(url, body, { responseType: 'text' });
}

otpForgotPassword(email: string, newPassword: string, confirmPassword: string) {
  const url = `${environment.authApiUrl}forgot-password`;
  const body = { email, newPassword, confirmPassword };
  return this.http.post(url, body);
}


    /**
     * Login user
     */
    login(username: string, password: string): Observable<any> {
        const url = `${environment.authApiUrl}login`;
        return this.http.post<any>(url, { username, password });
    }

    /**
     * Get all users
     */
    getAllUsers() {
        const url = `${environment.authApiUrl}list`;
        return this.http.get<any[]>(url);
    }

    /**
     * Get verified (active) users list
     */
    getVerifiedUsers(): Observable<any[]> {
        const url = `${environment.authApiUrl}list/verified`;
        return this.http.get<any[]>(url);
    }

    forgotPassword(body: { email: string; newPassword: string; confirmPassword: string }): Observable<any> {
        console.log('Forgot Password Request Body:', body);
        return this.http.post(`${environment.authApiUrl}forgot-password`, body);
    }
}
